import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
            <div className="overlay"></div>
            );

export default Footer